import type { FetchTicketResponse } from "src/api/models";
import type { MenuItem } from "../types";

export function createQuickViewMenuItem(
  ticket: FetchTicketResponse,
  handlers: {
    showQuickView: () => void;
  }
): MenuItem {
  return {
    label: "View Pictures",
    icon: "pi pi-eye",
    command: handlers.showQuickView
  };
}
